var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('charity-rep-table-template',{ref:"charityRepTableTemplate",attrs:{"charity-id":_vm.charityId}})}
var staticRenderFns = []

export { render, staticRenderFns }